/**
 * KET Vocabulary - Leisure and Hobbies Theme (100 words)
 */
import { KETWord } from './index';

export const leisureHobbiesWords: KETWord[] = [
  { word: 'sport', meaning: '运动', example: 'I like sports.' },
  { word: 'football', meaning: '足球', example: 'I play football with friends.' },
  { word: 'basketball', meaning: '篮球', example: 'I play basketball.' },
  { word: 'tennis', meaning: '网球', example: 'My dad plays tennis.' },
  { word: 'volleyball', meaning: '排球', example: 'We play volleyball in PE.' },
  { word: 'badminton', meaning: '羽毛球', example: 'I like badminton.' },
  { word: 'table tennis', meaning: '乒乓球', example: 'Table tennis is popular in China.' },
  { word: 'swimming', meaning: '游泳', example: 'I go swimming in summer.' },
  { word: 'running', meaning: '跑步', example: 'I like running in the morning.' },
  { word: 'jogging', meaning: '慢跑', example: 'My mom goes jogging every day.' },
  { word: 'cycling', meaning: '骑车', example: 'I enjoy cycling.' },
  { word: 'skating', meaning: '滑冰', example: 'I go skating in winter.' },
  { word: 'skiing', meaning: '滑雪', example: 'I want to try skiing.' },
  { word: 'hiking', meaning: '徒步', example: 'We went hiking last weekend.' },
  { word: 'yoga', meaning: '瑜伽', example: 'My mom does yoga.' },
  { word: 'music', meaning: '音乐', example: 'I listen to music.' },
  { word: 'song', meaning: '歌曲', example: 'I like this song.' },
  { word: 'sing', meaning: '唱歌', example: 'I like to sing.' },
  { word: 'dance', meaning: '跳舞', example: 'I like dancing.' },
  { word: 'piano', meaning: '钢琴', example: 'I play the piano.' },
  { word: 'guitar', meaning: '吉他', example: 'My brother plays the guitar.' },
  { word: 'violin', meaning: '小提琴', example: 'She plays the violin.' },
  { word: 'concert', meaning: '音乐会', example: 'We went to a concert.' },
  { word: 'game', meaning: '游戏', example: 'I play games after school.' },
  { word: 'video game', meaning: '电子游戏', example: 'I like video games.' },
  { word: 'computer game', meaning: '电脑游戏', example: 'My favorite is a computer game.' },
  { word: 'board game', meaning: '桌面游戏', example: 'We play board games together.' },
  { word: 'card game', meaning: '纸牌游戏', example: 'I like card games.' },
  { word: 'chess', meaning: '国际象棋', example: 'I play chess with my dad.' },
  { word: 'puzzle', meaning: '拼图', example: 'I like doing puzzles.' },
  { word: 'toy', meaning: '玩具', example: 'Children like toys.' },
  { word: 'art', meaning: '艺术', example: 'I like art class.' },
  { word: 'draw', meaning: '画画', example: 'I like to draw.' },
  { word: 'paint', meaning: '绘画', example: 'I paint pictures.' },
  { word: 'picture', meaning: '图画', example: 'I drew a picture.' },
  { word: 'photograph', meaning: '照片', example: 'I take photographs.' },
  { word: 'photo', meaning: '照片', example: 'Take a photo of me.' },
  { word: 'camera', meaning: '相机', example: 'I use my camera.' },
  { word: 'read', meaning: '阅读', example: 'I read books every day.' },
  { word: 'book', meaning: '书', example: 'This is my favorite book.' },
  { word: 'magazine', meaning: '杂志', example: 'I read magazines.' },
  { word: 'comic', meaning: '漫画', example: 'I like reading comics.' },
  { word: 'newspaper', meaning: '报纸', example: 'My dad reads the newspaper.' },
  { word: 'story', meaning: '故事', example: 'I like listening to stories.' },
  { word: 'novel', meaning: '小说', example: 'I am reading a novel.' },
  { word: 'film', meaning: '电影', example: 'I watch films on weekends.' },
  { word: 'movie', meaning: '电影', example: 'Let\'s watch a movie.' },
  { word: 'cinema', meaning: '电影院', example: 'We went to the cinema.' },
  { word: 'theater', meaning: '剧院', example: 'We went to the theater.' },
  { word: 'TV', meaning: '电视', example: 'I watch TV in the evening.' },
  { word: 'television', meaning: '电视', example: 'The television is on.' },
  { word: 'program', meaning: '节目', example: 'My favorite program is on TV.' },
  { word: 'channel', meaning: '频道', example: 'Change the channel.' },
  { word: 'cartoon', meaning: '动画片', example: 'I like watching cartoons.' },
  { word: 'video', meaning: '视频', example: 'I watched a video online.' },
  { word: 'hobby', meaning: '爱好', example: 'My hobby is reading.' },
  { word: 'collection', meaning: '收藏', example: 'I have a stamp collection.' },
  { word: 'collect', meaning: '收集', example: 'I collect coins.' },
  { word: 'stamp', meaning: '邮票', example: 'I collect stamps.' },
  { word: 'coin', meaning: '硬币', example: 'I have a coin collection.' },
  { word: 'garden', meaning: '园艺', example: 'My mom likes gardening.' },
  { word: 'cooking', meaning: '烹饪', example: 'I enjoy cooking.' },
  { word: 'baking', meaning: '烘焙', example: 'I like baking cakes.' },
  { word: 'fishing', meaning: '钓鱼', example: 'My dad likes fishing.' },
  { word: 'party', meaning: '派对', example: 'I had a birthday party.' },
  { word: 'picnic', meaning: '野餐', example: 'We had a picnic in the park.' },
  { word: 'barbecue', meaning: '烧烤', example: 'We had a barbecue.' },
  { word: 'trip', meaning: '旅行', example: 'We went on a school trip.' },
  { word: 'visit', meaning: '拜访', example: 'I visit my grandparents.' },
  { word: 'meet', meaning: '见面', example: 'Let\'s meet at the park.' },
  { word: 'chat', meaning: '聊天', example: 'I chat with my friends online.' },
  { word: 'talk', meaning: '谈话', example: 'We talked for hours.' },
  { word: 'park', meaning: '公园', example: 'I play in the park.' },
  { word: 'playground', meaning: '操场', example: 'Children play on the playground.' },
  { word: 'beach', meaning: '海滩', example: 'We went to the beach.' },
  { word: 'pool', meaning: '游泳池', example: 'I swim in the pool.' },
  { word: 'gym', meaning: '健身房', example: 'My dad goes to the gym.' },
  { word: 'stadium', meaning: '体育场', example: 'We watched a match at the stadium.' },
  { word: 'museum', meaning: '博物馆', example: 'We visited the museum.' },
  { word: 'gallery', meaning: '画廊', example: 'We went to an art gallery.' },
  { word: 'zoo', meaning: '动物园', example: 'I like going to the zoo.' },
  { word: 'library', meaning: '图书馆', example: 'I borrow books from the library.' },
  { word: 'play', meaning: '玩', example: 'I play football.' },
  { word: 'watch', meaning: '观看', example: 'I watch TV.' },
  { word: 'listen', meaning: '听', example: 'I listen to music.' },
  { word: 'enjoy', meaning: '享受', example: 'I enjoy reading.' },
  { word: 'like', meaning: '喜欢', example: 'I like sports.' },
  { word: 'love', meaning: '热爱', example: 'I love music.' },
  { word: 'hate', meaning: '讨厌', example: 'I hate rainy days.' },
  { word: 'prefer', meaning: '更喜欢', example: 'I prefer tea to coffee.' },
  { word: 'relax', meaning: '放松', example: 'I relax on weekends.' },
  { word: 'have fun', meaning: '玩得开心', example: 'We had fun at the party.' },
  { word: 'fun', meaning: '有趣的', example: 'The game is fun.' },
  { word: 'interesting', meaning: '有趣的', example: 'The book is interesting.' },
  { word: 'exciting', meaning: '令人兴奋的', example: 'The match was exciting.' },
  { word: 'boring', meaning: '无聊的', example: 'The film was boring.' },
  { word: 'popular', meaning: '流行的', example: 'Football is a popular sport.' },
  { word: 'favorite', meaning: '最喜欢的', example: 'What is your favorite sport?' },
  { word: 'free', meaning: '空闲的', example: 'I am free this weekend.' },
  { word: 'busy', meaning: '忙碌的', example: 'I am busy with homework.' },
];